export enum DraftTaskType {
  txt2img = "txt2img",
  img2img = "img2img",
}
export enum DraftModelType {
  sd = "sd",
  pixiv = "pixiv",
  pixiv_hand = "pixiv_hand",
  // game_icon = "game_icon",
  indoor_design = "indoor_design",
  sd_20 = "sd_20",
  "architecture" = "architecture", //建筑模型
  "comic" = "comic", //漫画模型
  "arcane" = "arcane", //双城之战
  "food" = "food", //食物模型
  "pixel" = "pixel", //像素模型
  "retro" = "retro", //复古漫画
  "photo" = "photo", //照片质感
  "dream_art" = "dream_art", //梦幻画风
  "oil_paint" = "oil_paint", //油画质感
  "acg" = "acg", //ACG
  "soft" = "soft", //柔和氛围感
  "3D" = "3D", //3D概念设计
  "sam" = "sam", //手绘插画
  "inkpunk" = "inkpunk", //墨水朋克
  "petal" = "petal", //花瓣背景
  "3D_icon" = "3D_icon", //3D图标
  "cartoon_wallpaper" = "cartoon_wallpaper", //动漫壁纸
  "character_simulation" = "character_simulation", //人物仿真
  "antique_photo" = "antique_photo", //古风照片
  "crayon" = "crayon", //蜡笔画
  "colorful_art" = "colorful_art", //多彩艺术
  "2_5D_antique" = "2_5D_antique", //2.5D古风
}

// open api doc https://creator-nolibox.apifox.cn/api-56157562?nav=1
export type AllDraftTaskType = `${DraftTaskType}.${DraftModelType}`;

export type DraftParams = {
  task: AllDraftTaskType;
  params: {
    text?: string;
    url?: string; // img2img
    fidelity?: number; //default 0.2  [0, 1] img2img
    w: number; //512, 768, 1024
    h: number; //512, 768, 1024
  };
};
